import { OrganogramDto } from './OrganogramDto';

export interface OrganogramBatchModel {
    organograms: OrganogramDto[],
    categoriesId: number[]
}

export const organogramBatchModelInitial: OrganogramBatchModel = {
    organograms: [],
    categoriesId: []
};